import React,{Component} from 'react';
import { NavBar,InputItem,Toast,Modal} from 'antd-mobile';
import {getDiscount} from "../../../service/memberService";
import './style.less'
import {connect} from "react-redux";
const ticket = require('../../../common/image/ticket.png');
const coupon = require('../../../common/image/coupon.png');
const employBtn = require('../../../common/image/employBtn.png');
const alert = Modal.alert;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class ExchangeCoupon extends Component{
    constructor(props) {
        super(props);
        this.state={
            phone:"",
            code:"",
            modal:false,
        }
    }
    componentDidMount() {}
    invite(){
        if(this.state.code == ""){
            Toast.info("请输入兑换码！");
            return
        }
        if(this.state.phone == ""){
            Toast.info("请输入绑定手机号码！");
            return
        }
        Toast.loading("",0);
        let params={
            couponNum:this.state.code,
            phone:this.state.phone.replace(/\s/ig, ''),
        };
        getDiscount(params).then((res)=>{
            if(res.data.code == '0000'){
                Toast.hide();
                this.setState({modal:true});
            }else{
                Toast.hide();
                alert(null,res.data.msg, [
                    { text: '关闭', onPress: () => this.setState({modal:false}) },
                ]);
            }
        })
    }
    render(){
        return(
            <div className="couponScreen">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >优惠券兑换</NavBar>
                <div className="content">
                    <img src={coupon} alt=""/>
                    <div className="formBox">
                        <InputItem
                            clear
                            placeholder="请输入兑换码"
                            onChange={(v)=>this.setState({code:v})}
                        >
                        </InputItem>
                        <InputItem
                            clear
                            placeholder="请输入绑定手机号"
                            type="phone"
                            onChange={(v)=>this.setState({phone:v})}
                        >
                        </InputItem>
                        <div className="getCoupons">
                            <button onClick={()=>this.invite()}></button>
                        </div>
                        <div className="couponsInfo">
                            <div className="title">优惠券兑换说明</div>
                            <div className="info">
                                <p>1.一张优惠券只可使用一次；</p>
                                <p>2.超过优惠券有效期限的兑换码无法成功兑换；</p>
                                <p>3.手机号必须为民途出行微信公众号登录时绑定的手机号，否则无法领取到账。</p>
                            </div>
                        </div>
                        {/*<p onClick={()=>this.props.history.push('/regulation')}>查看奖励规则<i className="icon iconfont icon-gengduo"></i></p>*/}
                    </div>
                </div>
                <Modal
                    visible={this.state.modal}
                    className="couponModal"
                >
                    <div className="">
                        <img src={ticket} className="bg"/>
                        <img src={employBtn} className='btn' onClick={()=>this.props.history.push('/pay/home')}/>
                        <i className="icon iconfont iconchacha1" onClick={()=>this.setState({modal:false})}></i>
                        {/*<button onClick={()=>this.employ()}>去使用</button>*/}
                    </div>
                </Modal>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/ExchangeCoupon/index.js